export const NAV_LINKS = [
  { label: "Company", to: "/company" },
  { label: "Expertise", to: "/expertise" },
  { label: "Projects", to: "/projects" },
  { label: "Approach", to: "/approach" },
  { label: "Contact", to: "/contact" },
];

export const COMPANY = {
  name: "Arch Expo AG",
  tagline: "From concept to completion.",
  email: "trendiarh@gmail.com",
  linkedin: "https://www.linkedin.com/company/arch-expo-ag",
  address: ["Arch Expo AG", "c/o do well GmbH", "Gewerbestrasse 5", "6330 Cham", "Switzerland"],
  companyNumber: "CHE-115.384.810",
};

export const PROCESS_PHASES = [
  {
    number: "01", name: "Discover",
    objective: "Understand the ambition, the site and the constraints before any decision is made.",
    activities: ["Brief development", "Site and context analysis", "Feasibility and due diligence", "Stakeholder mapping"],
    deliverables: ["Project brief", "Feasibility report", "Initial risk register"],
    decisions: "Go / no-go on feasibility and project definition.",
    client: "Intensive — workshops, site visits and ambition setting.",
  },
  {
    number: "02", name: "Define",
    objective: "Fix the framework: scope, budget, programme and the team that will deliver it.",
    activities: ["Scope definition", "Budget framework", "Programme strategy", "Consultant appointment"],
    deliverables: ["Defined scope of services", "Cost plan", "Master programme"],
    decisions: "Approval of scope, budget and programme baseline.",
    client: "High — sign-off on the framework that governs the project.",
  },
  {
    number: "03", name: "Design",
    objective: "Develop the spatial concept into a coordinated, buildable design.",
    activities: ["Concept design", "Spatial planning", "Material direction", "Interdisciplinary coordination"],
    deliverables: ["Concept package", "Design development set", "Material palette"],
    decisions: "Design freeze at each stage gate.",
    client: "Regular design reviews at defined milestones.",
  },
  {
    number: "04", name: "Plan",
    objective: "Translate design into technical documentation, permits and execution strategy.",
    activities: ["Technical design", "Planning permission", "Tender documentation", "Execution planning"],
    deliverables: ["Permit set", "Tender package", "Execution plan"],
    decisions: "Appointment of contractors and suppliers.",
    client: "Targeted — key approvals, tender decisions.",
  },
  {
    number: "05", name: "Source",
    objective: "Procure materials, products and services through our international network.",
    activities: ["Supplier qualification", "Tender comparison", "Order management", "Logistics coordination"],
    deliverables: ["Procurement schedule", "Order confirmations", "Logistics plan"],
    decisions: "Selection of suppliers and final order placement.",
    client: "Transparent — comparison reports and recommendations.",
  },
  {
    number: "06", name: "Build",
    objective: "Execute with precision — supervised, documented and quality-controlled.",
    activities: ["Contractor coordination", "Site supervision", "Quality control", "Cost and programme control"],
    deliverables: ["Progress reports", "Quality records", "Updated cost forecasts"],
    decisions: "Change management and site instructions.",
    client: "Informed — structured reporting, site walks on request.",
  },
  {
    number: "07", name: "Deliver",
    objective: "Hand over a finished, documented and performing asset.",
    activities: ["Snagging and defect management", "Commissioning", "Documentation handover", "Aftercare"],
    deliverables: ["Handover documentation", "Defects list closure", "Final account"],
    decisions: "Acceptance and final sign-off.",
    client: "Conclusive — acceptance, handover and review.",
  },
];

export const VALUES = [
  { name: "Integration", text: "Design, construction and sourcing coordinated as one discipline — not three contracts." },
  { name: "Precision", text: "Swiss standards of documentation, detailing and control at every project phase." },
  { name: "Accountability", text: "One partner, one responsibility. Clear ownership from first sketch to final handover." },
  { name: "Quality", text: "Materials, workmanship and information held to the same uncompromising standard." },
  { name: "Delivery", text: "Programme and budget treated as design parameters — not afterthoughts." },
];

export const ADVANTAGES = [
  { number: "01", title: "Single point of coordination", text: "One partner aligns architects, engineers, contractors and suppliers around a single programme." },
  { number: "02", title: "Design informed by execution", text: "Every design decision is tested against buildability, cost and lead time before it is fixed." },
  { number: "03", title: "International sourcing network", text: "Direct access to European manufacturers, fabricators and material specialists." },
  { number: "04", title: "Quality, budget and programme control", text: "Continuous cost and schedule control with transparent, structured reporting." },
  { number: "05", title: "Clear project accountability", text: "Defined responsibility for outcomes — from early strategy to final delivery." },
];

export const COMPANY_FACTS = [
  { label: "Legal form", value: "Aktiengesellschaft (AG)" },
  { label: "Disciplines", value: "Architecture · Interior Design · Construction · Procurement · Project Management" },
  { label: "Reach", value: "Switzerland · Europe · International" },
];

export const PROJECT_FILTERS = ["All", "Interior", "Renovation", "Residential", "Hospitality", "Procurement"];

export const PROJECT_TYPES = ["Interior", "Renovation", "Residential", "Commercial", "Hospitality", "Mixed-use", "Other"];

export const SERVICE_OPTIONS = ["Interior Design", "Renovation", "Architecture", "Construction", "Procurement", "Project Management", "Other"];

export const PROJECT_STAGES = ["Early idea", "Feasibility", "Design in progress", "Planning permission", "Ready to build", "Under construction"];

export const BUDGET_RANGES = ["Under CHF 250k", "CHF 250k – 1M", "CHF 1M – 5M", "CHF 5M+", "To be defined"];

export const PARTNERS = [
  {
    name: "Ghizzi & Benatti",
    url: "https://www.ghizziebenatti.it",
    category: "Doors & Boiserie",
    description: "Italian manufacturer of interior doors and boiserie wall panelling — from flush-to-wall to sliding and pivot systems, Made in Italy.",
  },
  {
    name: "Casabath",
    url: "https://www.casabath.it",
    category: "Bathroom Furniture",
    description: "High-end Italian bathroom furniture, washbasins and shower systems — crafted in Tuscany since 1987.",
  },
  {
    name: "Gamadecor",
    url: "https://www.gama-decor.com",
    category: "Kitchen & Bathroom Furniture",
    description: "Spanish kitchen and bathroom furniture from the Porcelanosa Group, including contract solutions for hotels and collective spaces.",
  },
  {
    name: "Porcelanosa Group",
    url: "https://www.porcelanosa.com",
    category: "Ceramics & Surfaces",
    description: "One of Europe's leading manufacturers of ceramic and porcelain tiles, surfaces and bathroom collections, based in Spain.",
  },
  {
    name: "Serapool",
    url: "https://www.serapool.com",
    category: "Pool Ceramics",
    description: "Turkish manufacturer of porcelain pool tiles and complete pool solutions — chosen for hotel and villa pools worldwide.",
  },
  {
    name: "Onok Lighting",
    url: "https://www.onoklighting.com",
    category: "Lighting",
    description: "Spanish technical and architectural LED lighting — modular systems and custom solutions for professional projects.",
  },
  {
    name: "PROLED",
    url: "https://www.proled.com",
    category: "Lighting",
    description: "German LED lighting manufacturer — LED strips, linear luminaires and outdoor solutions, developed and made in Germany.",
  },
  {
    name: "Inbeca",
    url: "https://www.inbeca.com",
    category: "Sauna & Wellness",
    description: "Custom wellness manufacturer from Spain — saunas, hammams, steam baths and spa equipment, crafted since 1964.",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=2000&q=80",
  brandMoment: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80",
  company: "https://images.unsplash.com/photo-1493397212122-2b85dda8106b?auto=format&fit=crop&w=1600&q=80",
  companyAlt: "https://images.unsplash.com/photo-1524230572899-a752b3835840?auto=format&fit=crop&w=1600&q=80",
  approach: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80",
  expertiseHero: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?auto=format&fit=crop&w=1600&q=80",
  contact: "https://images.unsplash.com/photo-1600121848594-d8644e57abab?auto=format&fit=crop&w=1600&q=80",
};
